const getPresentationData = (items, settings) => {
    let ovData = [];

    for (let item of items) {
        if (item.ovType === 'ov360' || item.ovType === 'ovtour') {
            ovData.push({
                id: item.ovType + '-' + item.id,
                inject: function () {
                    if (typeof this.inject.counter === 'undefined') {
                        this.inject.counter = 0;
                        if (item.ovType === 'ov360') {
                            window['inject_viewer_o360_' + item.id]();
                        } else {
                            window['inject_orbittour_otour_' + item.id]();
                        }
                    }
                    this.inject.counter++;
                },
                injectLightbox: function () {
                    if (settings['lightbox']['lightbox_enabled']) {
                        if (typeof this.injectLightbox.counter === 'undefined') {
                            if (item.ovType === 'ov360') {
                                window['inject_viewer_lightbox_' + item.id]();
                            } else {
                                window['inject_orbittour_lightbox_' + item.id]();
                            }
                        }
                    }
                    this.injectLightbox.counter++;
                }
            });
        } else if (item.ovType === 'ovvideo' || item.ovType === 'ovvideo-native') {
            if (item.ovType === "ovvideo-native" && !item.ovVideoProvider) {
                ovData.push({
                    id: item.ovType + '-' + item.id,
                    inject: function () {
                        document.getElementById('ovvideo-item-container').innerHTML = `
                            <video  src=${item.ovVideoData.url} controls="controls" class="orbitvu-video-source" />
                        `;
                    },
                    injectLightbox: function () {
                        if (settings['lightbox']['lightbox_enabled']) {
                            document.getElementById('ovvideo-lightbox_' + item.id).innerHTML = `
                            <video  src=${item.ovVideoData.url} controls="controls" class="orbitvu-video-source" />
                        `;
                        }
                    }
                });
            } else {
                ovData.push({
                    id: item.ovType + '-' + item.id,
                    inject: function () {
                        console.log(item);
                        if (item.ovVideoProvider === 'youtube') {
                            document.getElementById('ovvideo-item-container').innerHTML = `<iframe 
                            src="//www.youtube.com/embed/${item.ovVideoId}${settings.general.show_youtube_related_videos ? '?rel0' : ''}" 
                            frameborder="0" allowfullscreen class="orbitvu-video-source"></iframe>`;
                        } else if (item.ovVideoProvider === 'vimeo') {
                            document.getElementById('ovvideo-item-container').innerHTML = `<iframe 
                            src="//player.vimeo.com/video/${item.ovVideoId}" 
                            frameborder="0" allowfullscreen class="orbitvu-video-source"></iframe>`;
                        }
                    },
                    injectLightbox: function () {
                        if (settings['lightbox']['lightbox_enabled']) {
                            if (item.ovVideoProvider === 'youtube') {
                                document.getElementById('ovvideo-lightbox_' + item.id).innerHTML = `<iframe 
                                src="//www.youtube.com/embed/${item.ovVideoId}${settings.general.show_youtube_related_videos ? '?rel0' : ''}" 
                                frameborder="0" allowfullscreen class="orbitvu-video-source"></iframe>`;
                            } else if (item.ovVideoProvider === 'vimeo') {
                                document.getElementById('ovvideo-lightbox_' + item.id).innerHTML = `<iframe 
                                src="//player.vimeo.com/video/${item.ovVideoId}" 
                                frameborder="0" allowfullscreen class="orbitvu-video-source"></iframe>`;
                            }
                        }
                    }
                });
            }
        }
    }
    return ovData;
}

export default getPresentationData;